import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';

export default function PageTransition({ children, title }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const element = contentRef.current;
    if (!element) {
      setIsLoaded(true);
      return;
    }

    const mediaElements = Array.from(element.querySelectorAll('img, video'));
    
    if (mediaElements.length === 0) {
      setIsLoaded(true);
      return;
    }

    let loadedCount = 0;
    const checkDone = () => {
      loadedCount++;
      if (loadedCount >= mediaElements.length) setIsLoaded(true);
    };

    mediaElements.forEach((media) => {
      if (media.tagName === 'IMG') {
        if (media.complete) checkDone();
        else {
          media.addEventListener('load', checkDone);
          media.addEventListener('error', checkDone);
        }
      } else if (media.tagName === 'VIDEO') {
        if (media.readyState >= 3) checkDone();
        else {
          media.addEventListener('loadeddata', checkDone);
          media.addEventListener('error', checkDone);
        }
      }
    });

    const timeout = setTimeout(() => setIsLoaded(true), 3000);
    return () => clearTimeout(timeout);
  }, [children]);

  const formattedTitle = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
  const displayTitle = "• " + formattedTitle;

  return (
    <>
      <motion.div
        className="fixed z-9999 bg-zinc-900 pointer-events-none w-[150vw] h-dvh -left-[25vw]"
        initial={{ top: "100vh", borderTopLeftRadius: "100%", borderTopRightRadius: "100%" }}
        exit={{ top: "0vh", borderTopLeftRadius: "0%", borderTopRightRadius: "0%" }}
        transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      />

      <motion.div
        className="fixed z-9998 bg-zinc-900 flex items-center justify-center pointer-events-none overflow-hidden w-[150vw] h-dvh -left-[25vw]"
        initial={{ top: "0vh", borderBottomLeftRadius: "0%", borderBottomRightRadius: "0%" }}
        animate={isLoaded ? { top: "-100vh", borderBottomLeftRadius: "70%", borderBottomRightRadius: "70%" } : { top: "0vh" }}
        transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1], delay: 0.5 }}
      >
        <motion.div 
          className="text-white text-4xl md:text-5xl lg:text-6xl font-['Montserrat',sans-serif] font-medium [letter-spacing:-0px] flex items-center justify-center tracking-normal capitalize"
          transition={{ duration: 0.0, ease: "easeOut", delay: 0.0 }}
        >
          {displayTitle}
        </motion.div>
      </motion.div>

      <div ref={contentRef}>
        {children}
      </div>
    </>
  );
}